module.exports = __webpack_public_path__ + "141d4a85/img/ion_calendar-number.3ac5bd07.svg";